import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Check, X, Loader2, Heart, Home } from 'lucide-react';
import { api } from '../lib/api';

export default function DonationResult() {
  const [params] = useSearchParams();
  const conversationId = params.get('conversationId') || params.get('paymentId') || localStorage.getItem('yekuv_last_payment');
  const [state, setState] = useState({ loading: true, data: null });

  useEffect(() => {
    if (!conversationId) {
      setState({ loading: false, data: null });
      return;
    }
    const tick = async (tries = 0) => {
      try {
        const d = await api.iyzicoStatus(conversationId);
        if (d.status === 'pending' && tries < 8) {
          setTimeout(() => tick(tries + 1), 2000);
          return;
        }
        setState({ loading: false, data: d });
      } catch {
        setState({ loading: false, data: null });
      }
    };
    tick();
  }, [conversationId]);

  const success = state.data?.status === 'completed';
  const failed = state.data?.status === 'failed';

  return (
    <section className="min-h-[70vh] bg-cream grid place-items-center px-6 py-20">
      <div className="max-w-xl w-full bg-white rounded-3xl border border-ink-100 shadow-xl p-10 text-center" data-testid="donation-result">
        {state.loading && (
          <>
            <div className="w-20 h-20 rounded-full bg-cream-200 grid place-items-center mx-auto text-ink-500 animate-spin"><Loader2 className="w-8 h-8" /></div>
            <h1 className="font-display text-3xl mt-6">Ödemeniz işleniyor...</h1>
            <p className="text-ink-500 mt-3">Lütfen bu sayfayı kapatmayın, ödeme sonucu kontrol ediliyor.</p>
          </>
        )}

        {!state.loading && success && (
          <>
            <div className="w-20 h-20 rounded-full bg-emerald-50 grid place-items-center mx-auto text-emerald-600"><Check className="w-10 h-10" /></div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-emerald-700 font-bold mt-6">Bağışınız Alındı</div>
            <h1 className="font-display text-4xl mt-3">Teşekkür ederiz, {state.data.name}!</h1>
            <div className="font-display text-5xl tabular text-ink-600 mt-5">₺{(state.data.amount || 0).toLocaleString('tr-TR')}</div>
            <p className="text-ink-500 mt-4 max-w-md mx-auto">Bağışınız başarıyla alındı. Makbuzunuz yakında e-posta adresinize gönderilecek.</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/" className="inline-flex items-center gap-2 bg-ink-600 text-cream rounded-full px-5 h-11 font-semibold"><Home className="w-4 h-4" /> Anasayfa</Link>
              <Link to="/bagis" className="inline-flex items-center gap-2 bg-gold text-ink-700 rounded-full px-5 h-11 font-semibold"><Heart className="w-4 h-4" /> Yeni Bağış</Link>
            </div>
            <div className="mt-6 text-[10px] text-ink-400 tabular">İşlem No: {state.data.id}</div>
          </>
        )}

        {!state.loading && failed && (
          <>
            <div className="w-20 h-20 rounded-full bg-coral-50 grid place-items-center mx-auto text-coral-300"><X className="w-10 h-10" /></div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-coral-300 font-bold mt-6">Ödeme Başarısız</div>
            <h1 className="font-display text-3xl mt-3">İşlem tamamlanamadı</h1>
            <p className="text-ink-500 mt-4">Ödeme sırasında bir sorun oluştu. Lütfen kart bilgilerinizi kontrol edip tekrar deneyin veya farklı bir kart ile bağış yapın.</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/bagis" className="inline-flex items-center gap-2 bg-coral-300 text-ink-700 rounded-full px-5 h-11 font-semibold"><Heart className="w-4 h-4" /> Tekrar Dene</Link>
              <Link to="/iletisim" className="inline-flex items-center gap-2 border border-ink-200 text-ink-500 rounded-full px-5 h-11 font-semibold">Yardım Al</Link>
            </div>
          </>
        )}

        {!state.loading && !state.data && (
          <>
            <div className="w-20 h-20 rounded-full bg-ink-50 grid place-items-center mx-auto text-ink-400"><Heart className="w-10 h-10" /></div>
            <h1 className="font-display text-3xl mt-6">Bilgi bulunamadı</h1>
            <p className="text-ink-500 mt-3">Geçerli bir bağış işlem bilgisi bulunamadı.</p>
            <Link to="/bagis" className="mt-6 inline-flex items-center gap-2 bg-ink-600 text-cream rounded-full px-5 h-11 font-semibold">Bağış Sayfası</Link>
          </>
        )}
      </div>
    </section>
  );
}
